import React from 'react';

import { Layout } from 'components/Layout';
import { Heading, HeadingVariant } from 'components/Heading';

import styles from './ConsumerTerms.module.scss';

export const ConsumerTerms: React.FC = () => (
  <Layout>
    <div className={styles.wrapper}>
      <Heading level={1} variant={HeadingVariant.inverted}>
        Inköpsvillkor för köp från privatperson
      </Heading>
      <strong>Bilaga till Blipps Inköpsavtal</strong>
      <Heading level={3} variant={HeadingVariant.inverted}>
        1 Bakgrund och förutsättningar för giltigt Inköpsavtal
      </Heading>
      <p>
        1.1 Dessa Inköpsvillkor gäller tillsammans med Inköpsavtal (benämns tillsammans
        ”Inköpsavtalet”) vid en fordonsaffär där Blipp AB, Prinsgatan 1, 541 31 Skövde, Orgnr
        556866-0681 ©2021, tel. nummer 010-106 06 06, i egenskap av köpare i syfte att sälja vidare
        ett fordon till näringsidkare eller konsument, ingår avtal med säljaren i egenskap av
        privatperson om köp av fordonet. Utöver Inköpsavtalet är Köplag (1990:931) tillämplig som
        utfyllande lagstiftning.
      </p>
      <p>
        1.2 För Inköpsavtalets giltighet krävs att den ursprungliga säljaren och köparen genomfört
        Blipps checklistor (“Blipps Checklistor”), Kontrollprocess (“Kontroll”) och Digitala
        varudeklaration (“DVDN), och får dessa godkända av Blipp. Oavsett om Inköpsavtal tecknats
        innan eller efter utförande av Checklistor, Kontroll och DVDN, så är Inköpsavtalets
        giltighet avhängigt Blipps godkännande av dessa. Blipp bestämmer ensidigt om Blipps
        Checklistor, Kontrollen och DVDN är uppfyllda och ska godkännas.
      </p>
      <p>
        1.3 Inköpsavtalets giltighet är avhängigt att Blipp tecknat Köpekontrakt Finansbolag, med en
        senare köpare av fordonet, och det finansbolag som Blipp vid var tid gällande har samarbete
        med, i anslutning till att Inköpsavtalet undertecknats. Om inte Köpekontrakt Finansbolag
        tecknats mellan Blipp, finansbolag och senare köpare är Inköpsavtalet ogiltigt, och
        eventuella prestationer ska omedelbart återgå.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        2 Definitioner
      </Heading>
      <p>
        2.1 Blipps digitala lösning för bilaffär via Blipps hemsida Blipp.se benämns i detta avtal
        <strong>”Tjänsten”</strong>.
      </p>
      <p>
        2.2 Den bil som är föremål för köpet definieras under <strong>”Köpeobjekt”</strong> i Blipps
        Inköpsavtal och benämns i dessa villkor som <strong>”Fordonet”</strong>.
      </p>
      <p>
        2.3 Med <strong>”Säljare”</strong> eller <strong>”Ursprunglig Säljare”</strong> avses i
        dessa Inköpsvillkor den eller de privatpersoner (Säljare 1 och Säljare 2 i Inköpsavtalet)
        som enligt detta Inköpsavtal säljer Fordonet till Blipp, och vars fordon Blipp ämnar sälja
        vidare till Köparen.
      </p>
      <p>
        2.4 Med <strong>”Köpare”</strong> avses den eller de konsumenter som undertecknar
        Köpekontrakt Finansbolag för Fordonet.
      </p>
      <p>
        2.5 Med <strong>”Köpekontrakt Finansbolag”</strong> avses det köpekontrakt som tecknas av
        Blipp, Köpare och med det finansbolag som Blipp vid var tid gällande har samarbete med, som
        utöver fordonsaffären i sig är en del av Köparens kreditavtal med det eller de finansbolag
        som Blipp vid var tid gällande har samarbete med.
      </p>
      <p>
        2.6 <strong>”Checklista Säljare”</strong> är en punktlista som den Ursprungliga Säljaren
        måste genomföra och uppfylla för att kunna sälja sitt fordon till Blipp. Punktlistan består
        av att den Ursprungliga Säljaren uppfyller följande kriterier vid tidpunkten för provkörning
        och eventuell affär:
      </p>
      <ul>
        <li>
          Har med sig det senast utfärdade registreringsbeviset del två för Fordonet med korrekt
          kontrollnummer. Även kallad ”den gula lappen”.
        </li>
        <li>
          Har valt bankkonto till Säljarens eget bankkonto via Blipps samarbetspartner Trustly, och
          därmed kopplat sitt bankkonto till Tjänsten och sitt användarkonto på Blipp.
        </li>
        <li>
          Har tillgång till sin e-post registrerade i Tjänsten via sin mobil, och har tillgång till
          sin mobil.
        </li>
        <li>Har sitt eget mobila BankID på sin mobil.</li>
      </ul>
      <p>
        2.7 <strong>”Checklista Köpare”</strong> är en punktlista som Köparen måste genomföra och
        uppfylla för att köpa Fordonet av Blipp. Punktlistan består av att Köparen uppfyller
        följande kriterier vid tidpunkten för provkörning och eventuell affär:
      </p>
      <ul>
        <li>
          Har höjt sin beloppsgräns för betalning via mobilen, t.ex. via Swish eller internetbank,
          till att minst motsvara beloppet av kontantinsatsen och Blipps eventuella arvode, som ska
          betalas till Blipp vid avlämnandet av Fordonet, och då betalar avtalad kontantinsats och
          eventuellt arvode till Blipp.
        </li>
        <li>
          Har tillgång till sin e-post som registrerats i Tjänsten, via sin mobil, och har tillgång
          till sin mobil.
        </li>
        <li>Har sitt eget mobila BankID på sin mobil.</li>
      </ul>
      <p>
        2.8 <strong>”Blipps Checklistor”</strong> är benämningen på Checklista Säljare och
        Checklista Köpare när dessa båda åsyftas tillsammans.
      </p>
      <p>
        2.9 <strong>”Kontroll”</strong> är en standard upprättad av Blipp där den Ursprungliga
        Säljaren, Köparen och Fordonet kontrolleras digitalt mot bilregister, värderingssajter,
        sociala medier, adressregister m.m..
      </p>
      <p>
        2.10 <strong>”DVDN”</strong> är en process för att identifiera dig som Ursprunglig Säljare
        och Köparen, kontrollera att Fordonet är på uppgiven plats och kontrollera Fordonets skick.
        DVDN sker ihop med Köparen och representant från Blipp. DVDN genomförs genom att
        representant från Blipp ringer upp den Ursprungliga Säljaren och Köparen via videolänk och
        spelar in videoupptagningen. I samband med DVDN upprättar Blipps representant ett protokoll
        avseende resultatet av DVDN. Inspelningen sparas av Blipp under felansvarsperioden, låneoch
        eventuell garantiperiod och används endast vid eventuell tvist mellan någon av parterna dvs.
        Blipp, den Ursprungliga Säljaren eller Köparen, eller tvist eller skadeanmälan hos
        försäkring eller finansbolag. Detta skulle t.ex. kunna vara för att hantera
        reklamationsärenden. Blipp har rätt att lämna ut DVDN till försäkringsbolag. Du äger ej rätt
        till att ta del av inspelningen. DVDN och protokoll till DVDN benämns tillsammans ”DVDN”.
      </p>
      <p>
        2.11 <strong>”Protokoll till DVDN”</strong> är för en Säljare de punkter som tas upp i
        fritextfältet på Inköpsavtalet och för en Köpare den varudeklaration som motsvarar en
        varudeklaration innehållande de obligatoriska moment som överenskommits mellan
        Motorbranschens Riksförbund och Konsumentverket. I Protokollet till DVDN eller i
        Inköpsavtalet görs noteringar om något är felaktigt, trasigt, slitet eller saknas
        beträffande Fordonet. DVDN och Protokoll till DVDN benämns tillsammans ”DVDN” och är en del
        av Inköpsavtalet.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        3 Solidariskt ansvar
      </Heading>
      <p>
        3.1 Om Säljaren äger fordonet tillsammans, dvs. om Säljaren är flera personer, så är de
        solidariskt ansvariga för förpliktelserna i Inköpsavtalet. Detta innebär att Blipp vid
        eventuella reklamationer eller andra krav kan rikta sig gentemot vilken av Säljarna som
        helst.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        4 Säljarens upplysningsplikt och felansvar
      </Heading>
      <p>
        4.1 Vid en reklamation från Köparen till Blipp så kommer Blipp i alla lägen att först
        åberopa den eventuella begagnatgaranti som tecknats av Köparen. Det ska kännas tryggt att
        sälja sitt fordon via Blipp. Säljaren är bara ansvarig för de köprättsliga fel som finns vid
        tillfället för undertecknandet av detta avtal och avlämnande av Fordonet, eller annorlunda
        uttryckt vid riskens övergång
      </p>
      <p>
        4.2 För att ett fel ska falla inom Säljarens felansvar ska det förutom att felet ska ha
        funnits vid riskens övergång, även vara ett så kallat köprättsligt fel. Fel föreligger t.ex.
        om fordonet i fråga om art, mängd, kvalitet, eller andra egenskaper inte stämmer överens med
        vad som följer av Inköpsavtalet. I detta hänseende ska vad som framkommer i DVDN,
        protokollet över DVDN, Kontrollen och Blipps Checklistor och eventuella överenskommelser som
        träffas i DVDN tillmätas betydelse för bedömningen om felet förelåg vi mottagandet av
        Fordonet, samt vara en del av Inköpsavtalet.
      </p>
      <p>
        4.3 Fordonet säljs i befintligt skick men Säljaren tillskrivs en upplysningsplikt. Säljaren
        är således skyldig att upplysa Blipp inte bara om relevant teknisk information, utan även
        upplysa Blipp om ev. skador eller brister i fordonet som Säljaren känner till eller borde
        känna till. Detta kan t.ex. vara, men är inte begränsat till, att Säljaren känner till en
        skada på fordonet som ej reparerats. Om fel eller annan information uppdagas efter riskens
        övergång, där felet eller informationen varit sådant att Säljaren har känt till detta fel
        eller informationen, eller borde ha känt till detta, ska en sådan brist i upplysningsplikten
        leda till en rätt för Blipp att reklamera felet. Är felet väsentligt kan det leda till en
        rätt att häva köpet. Undanhållande eller uppgiven falsk information som klassas som
        bedrägeri enligt brottsbalken polisanmälas utan undantag.
      </p>
      <p>
        4.4 Fordonet säljs i befintligt skick och Blipp undersöker fordonet grundligt tillsammans
        med Köparen och den Ursprungliga säljaren. Blipp kan inte åberopa fel som Blipp haft fog att
        förutsätta redan fanns vid tidpunkten för tecknandet av detta Inköpsavtal och vid
        avlämnandet av Fordonet. Av denna anledning lägger Blipp stor vikt vid att DVDN genomförs
        tillsammans med samtliga parter, dvs. den Ursprungliga Säljaren, Blipp och Köparen
        tillsammans, så att affären blir så trygg som möjligt. Blipp är tillsammans med Köparen även
        skyldiga att som en del i sin undersökningsplikt undersöka att avtalade tillbehör finns i
        bilen, så som t.ex. servicebok, extradäck, dragkrok, låsbult, insynsskydd etc.. DVDN blir
        ett underlag för vad Blipp och Köparen kände till vid avlämnandet och med fog kunnat
        förutsätta. Av denna anledning ska Blipp och Köparen bekräfta att DVDN genomförts, protokoll
        upprättats, och godkänna vad som har framkommit av DVDN och dess protokoll innan
        Köpekontrakt Finansbolag tecknas. Sammanfattningsvis innebär detta att fel som framkommer
        vid DVDN och Blipp och Köparens övriga undersökning inte kan reklameras som fel och omfattas
        inte av Säljarens felansvar.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        5 Reklamation
      </Heading>
      <p>
        5.1 Om fel ska reklameras mot Säljaren, ska Blipp reklamera felet hos Säljaren så snart som
        möjligt. En reklamation ska göras inom skälig tid från det att Blipp märkt felet. En
        reklamation som har gjorts inom två månader efter det att Blipp har fått kännedom om felet
        ska alltid anses ha kommit in i rätt tid. Blipp har rätt att reklamera fel i fordonet inom
        två år från Inköpsavtalets undertecknande.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        6 Leverans
      </Heading>
      <p>
        6.1 Avlämnande av Fordonet sker direkt på platsen för affären i samband med att Inköpsavtal
        och Köpekontrakt Finansbolag signeras. Avlämnandet sker till Köparen.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        7 Blipps förpliktelser, betalningssätt och lösen av lån
      </Heading>
      <p>
        7.1 Blipp löser eventuella befintliga billån som belastar fordonet och betalar ut resterande
        del av köpeskillingen direkt till Säljarens angivna bankkonto som Säljaren enligt Checklista
        Säljare kopplat till tjänsten via Blipps samarbetspartner Trustly efter att Blipp har
        godkänt DVDN, Checklistor och Kontroll, giltigt Inköpsavtal tecknats mellan Säljaren och
        Blipp, och giltigt Köpekontrakt Finansbolag tecknats mellan Blipp, Köparen och
        finansbolaget, samt att samtliga registreringar i affären är utförda (ägarregistrering av
        Fordonet på Blipp i bilregistret, ägarregistrering av Fordonet på Köparen i bilregistret
        samt registreringar på Köpare i form av kreditmarkering av Fordonet och uppläggning av
        eventuell försäkring och eventuell garanti för Fordonet).
      </p>
      <p>
        7.2 Resterande del av köpeskillingen betalas utan undantag endast ut till Säljarens eget
        konto som via Blipps samarbetspartner Trustly har kopplats till Säljarens användarkonto i
        Tjänsten.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        8 Säljarens huvudsakliga förpliktelser
      </Heading>
      <p>
        8.1 Säljaren garanterar att Fordonet är Säljarens egendom att Säljaren är registrerad ägare
        av Fordonet i bilregistret, fritt från belastningar och att det inte är föremål för någon
        tvångs-säkerhetsåtgärd.
      </p>
      <p>
        8.2 Säljaren garanterar att Fordonet och Fordonets utrustning vid riskens övergång motsvarar
        det som Säljaren uppgivit. Detta kan t.ex. vara information om bilens utrustningspaket. I
        detta garanterar Säljaren att denna inte har undanhållit information för Blipp om vad som
        för Säljaren vid försäljningstillfället är kända fel.
      </p>
      <p>
        8.3 Säljaren, eller signerande representant för Säljaren, garanterar att, om tillämpligt,
        undertecknande av Inköpsavtalet sker av behörig firmatecknare och åtar sig att hålla Blipp
        skadelös om så inte skulle vara fallet.
      </p>
      <p>
        8.4 Säljaren garanterar att samtliga avgifter och skatter så som trängselskatt, fordonskatt,
        tullavgifter och böter som uppkommit före avtalets undertecknande betalats innan respektive
        förfallodatum.
      </p>
      <p>
        8.5 Säljaren garanterar att angivit och till Tjänsten kopplat kontonummer är korrekt och
        Blipp är inte på något sätt ansvariga för om Säljaren ej får tillgång till köpeskillingen
        p.g.a. felaktigt angivet kontonummer.
      </p>
      <p>
        8.6 Säljaren garanterar att bilen under provkörning av Köparen har en gällande
        trafikförsäkring. Säljaren åtar sig att hålla Blipp och Köpare skadelösa vid eventuella
        skador under provkörningen, både sak och personskador. Däremot åtar sig Blipp, om
        försäkringsbolag åtar sig en skada, att stå för självrisken på Säljarens Trafikförsäkring om
        inte skadan uppkommit genom grov oaktsamhet eller uppsåt.
      </p>
      <p>
        8.7 Utöver det som stadgas i detta Inköpsavtal så ska köplagen tillämpas som utfyllande
        lagstiftning vilket innebär, men är inte begränsat till, att Säljaren lyder under
        felansvaret i köplagen och fel kan reklameras enligt köplagens felbestämmelser.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        9 Blipps rätt till att begära ut servicehistorik
      </Heading>
      <p>
        9.1 Genom undertecknandet av detta Inköpsavtal ger Säljaren Blipp rätt att begära ut
        servicehistorik på Fordonet från verkstäder för service/reparationer som skett under den tid
        som Säljaren varit ägare till fordonet
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        10 Tvistelösning
      </Heading>
      <p>
        10.1 Svensk lag ska tillämpas på Inköpsavtalet och eventuell tvist med anledning av
        Inköpsavtalet, eller affären det beskriver, ska lösas i allmän svensk domstol.
      </p>
    </div>
  </Layout>
);
